import { useState, useEffect, useCallback } from 'react';
import { sortProjectsByRecentVisit } from '../utils/projectVisitUtils';

/**
 * 프로젝트 방문 기록 변경을 알리기 위한 커스텀 이벤트
 */
export const VISIT_HISTORY_CHANGE_EVENT = 'projectVisitHistoryChange';

/**
 * 프로젝트 방문 기록 변경을 다른 컴포넌트에 알리는 함수
 */
export const notifyVisitHistoryChange = (): void => {
    window.dispatchEvent(new CustomEvent(VISIT_HISTORY_CHANGE_EVENT));
};

/**
 * 프로젝트 방문 기록을 실시간으로 추적하고 프로젝트 배열을 정렬된 상태로 반환하는 훅
 */
export const useProjectVisitHistory = <T extends { id: string }>(
    projects: T[]
): T[] => {
    const [visitHistoryVersion, setVisitHistoryVersion] = useState(0);

    // 방문 기록 변경 감지
    useEffect(() => {
        const handleVisitHistoryChange = () => {
            setVisitHistoryVersion(prev => prev + 1);
        };

        window.addEventListener(
            VISIT_HISTORY_CHANGE_EVENT,
            handleVisitHistoryChange
        );

        return () => {
            window.removeEventListener(
                VISIT_HISTORY_CHANGE_EVENT,
                handleVisitHistoryChange
            );
        };
    }, []);

    // 방문 기록이 변경될 때마다 프로젝트를 재정렬
    const sortedProjects = useCallback(() => {
        return sortProjectsByRecentVisit(projects);
    }, [projects]);

    return sortedProjects();
};
